import React, { useEffect, useState, useRef} from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import "../styles/Navy.css";
// import Resume from "./Resume";
import { FaPython, FaJava, FaCode,FaMicrochip, FaFileAlt, FaBuilding, FaBrain } from "react-icons/fa";
import { SiCplusplus } from "react-icons/si";
import { TbChartHistogram } from "react-icons/tb";

const ROADMAP_CARDS = [
  {
    icon: <FaPython />,
    title: "Python",
    desc: "High-level language for web, data science, automation, and AI.",
    course: "python",
  },
  {
    icon: <SiCplusplus />,
    title: "DSA",
    desc: "Data structures & algorithms combined with C/C++ for problem-solving.",
    course: "dsa",
  },
  {
    icon: <FaMicrochip />,
    title: "C",
    desc: "Procedural language for system programming and embedded apps.",
    course: "c",
  },
  {
    icon: <TbChartHistogram />,
    title: "Data Science",
    desc: "Extracting insights using statistics, programming, and ML.",
    course: "data science",
  },
  {
    icon: <FaJava />,
    title: "Java",
    desc: "Object-oriented language for web, mobile, and enterprise systems.",
    course: "java",
  },
];

// Interview Prep dropdown options
const INTERVIEW_CARDS = [
  {
    icon: <FaBuilding />,
    title: "Company Pattern Analysis",
    desc: "Explore hiring patterns, question trends, and rounds for specific companies.",
    path: "/company",
  },
  {
    icon: <FaBrain />,
    title: "Aptitude Practice",
    desc: "Sharpen your quantitative, logical, and verbal reasoning skills.",
    path: "/aptitude",
  },
  {
  icon: <FaCode />,
  title: "Practice",
  desc: "Practice coding with interactive exercises, quizzes, and challenges.",
  path: "/practice",
},
];

export default function Navy() {
  const navigate = useNavigate();
  const navRef = useRef(null);
  const closeTimerRef = useRef(null);

  const [megaMenu, setMegaMenu] = useState(null);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [user, setUser] = useState({
    name: "",
    email: "",
  });

  const location = useLocation();

  const shouldHideNav = location.state?.fromDashboard === true;

  useEffect(() => {
    const syncUser = () => {
      const token = localStorage.getItem("token");
      const storedUser = JSON.parse(localStorage.getItem("user") || "{}");

      if (token && storedUser?.name && storedUser?.email) {
        setUser({
          name: storedUser.name,
          email: storedUser.email,
        });
      } else {
        setUser({ name: "", email: "" });
      }
    };

    syncUser();

    window.addEventListener("user-login", syncUser);
    window.addEventListener("storage", syncUser);

    return () => {
      window.removeEventListener("user-login", syncUser);
      window.removeEventListener("storage", syncUser);
    };
  }, []);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (megaMenu && navRef.current && !navRef.current.contains(e.target)) {
        setMegaMenu(null);
      }
      if (mobileOpen && navRef.current && !navRef.current.contains(e.target)) {
        setMobileOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [megaMenu, mobileOpen]);

  // ✅ Single smart Dashboard button handler — logged in → dashboard, else → login
  const handleDashboardClick = () => {
    const token = localStorage.getItem("token");
    if (token && user.name) {
      navigate("/front", { replace: true });
    } else {
      navigate("/login");
    }
  };

  // Hover-with-gap-tolerance handlers for the mega menu
  const openMegaMenu = (name) => {
    if (closeTimerRef.current) {
      clearTimeout(closeTimerRef.current);
      closeTimerRef.current = null;
    }
    setMegaMenu(name);
  };

  const scheduleCloseMegaMenu = () => {
    closeTimerRef.current = setTimeout(() => {
      setMegaMenu(null);
    }, 250);
  };

  useEffect(() => {
    return () => {
      if (closeTimerRef.current) clearTimeout(closeTimerRef.current);
    };
  }, []);

//   const [resumeOpen, setResumeOpen] = useState(false);

// const handleResumeBuilderClick = () => {
//   const token = localStorage.getItem("token");
//   if (token && user.name) {
//     setResumeOpen(true);
//   } else {
//         alert("Please Login First")
// navigate("/login");
//   }
// };

  return (
    <div className="znav-wrap">
      <nav
        id="znav"
        ref={navRef}
        className={`znav-shell ${megaMenu ? "znav-flyout-open" : ""}`}
      >
        {/*------------------- TOP ROW ------------------*/}
        <div className="znav-top">
          {/*------------------- LOGO ------------------*/}
          <Link className="znav-brand" to="/">
            <img className="znav-logo-img" src="codematrixLogo.png" alt="logo" />
          </Link>

          <div className={`znav-collapse ${mobileOpen ? "znav-collapse-open" : ""}`}>
            {/* -----------------CENTER LINKS -----------------------*/}
            {!shouldHideNav && (
           <ul className="znav-links">
  <li className="znav-item">
    <Link className="znav-link" to="/" onClick={() => setMobileOpen(false)}>
      Home
    </Link>
  </li>
  <li className="znav-item">
    <Link className="znav-link" to="/about" onClick={() => setMobileOpen(false)}>
      About
    </Link>
  </li>

  <li
    className="znav-item"
    onMouseEnter={() => openMegaMenu("roadmaps")}
    onMouseLeave={scheduleCloseMegaMenu}
  >
    <span
      className={`znav-link znav-link-trigger ${megaMenu === "roadmaps" ? "znav-active" : ""}`}
      onClick={() => {
        navigate("/courses");
        setMegaMenu((m) => (m === "roadmaps" ? null : "roadmaps"));
      }}
    >
      Courses Roadmaps
      <svg className={`znav-chev ${megaMenu === "roadmaps" ? "znav-chev-flipped" : ""}`} width="11" height="11" viewBox="0 0 24 24" fill="none">
        <path d="M6 9l6 6 6-6" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    </span>
  </li>

  <li
    className="znav-item"
    onMouseEnter={() => openMegaMenu("interview")}
    onMouseLeave={scheduleCloseMegaMenu}
  >
    <span
      className={`znav-link znav-link-trigger ${megaMenu === "interview" ? "znav-active" : ""}`}
      onClick={() => setMegaMenu((m) => (m === "interview" ? null : "interview"))}
    >
      Interview Prep
      <svg className={`znav-chev ${megaMenu === "interview" ? "znav-chev-flipped" : ""}`} width="11" height="11" viewBox="0 0 24 24" fill="none">
        <path d="M6 9l6 6 6-6" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    </span>
  </li>

  <li className="znav-item">
    <a className="znav-link" href="https://codematrix.co.in/blog/" target="_blank" rel="noopener noreferrer">
      Blog
    </a>
  </li>

  <li className="znav-item">
    <Link className="znav-link" to="/contact" onClick={() => setMobileOpen(false)}>
      Contact
    </Link>
  </li>
</ul>
            )}
          </div>

          {shouldHideNav && <div className="znav-spacer-flex" />}

          {/* -----------------RIGHT SIDE — always visible, never hidden by the mobile collapse ---------------- */}
         <div className="znav-right">
  {/* <button className="znav-cta znav-cta-secondary" onClick={handleResumeBuilderClick}>
    <FaFileAlt className="znav-cta-icon" />
    Resume Builder
  </button> */}

  <button className="znav-cta" onClick={handleDashboardClick}>
    {user.name ? "Dashboard" : "Login"}
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none">
      <path
        d="M9 6l6 6-6 6"
        stroke="currentColor"
        strokeWidth="2.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </button>

  {/*------------------- TOGGLER (mobile) — rightmost --------------------- */}
  <button
    className={`znav-toggler ${mobileOpen ? "znav-toggler-active" : ""}`}
    type="button"
    aria-label="Toggle navigation"
    aria-expanded={mobileOpen}
    onClick={() => setMobileOpen((v) => !v)}
  >
    <span className={`znav-toggler-icon ${mobileOpen ? "znav-toggler-icon-open" : ""}`} />
  </button>
</div>
        </div>

        {/*------------------- MEGA FLYOUT PANEL: ROADMAPS ------------------*/}
        {megaMenu === "roadmaps" && (
          <div
            className="znav-flyout"
            onMouseEnter={() => openMegaMenu("roadmaps")}
            onMouseLeave={scheduleCloseMegaMenu}
          >
            <div className="znav-flyout-divider" />
            <div className="znav-flyout-grid">
              {ROADMAP_CARDS.map((card) => (
                <Link
                  key={card.course}
                  to="/courses"
                  state={{ course: card.course }}
                  className="znav-flyout-card"
                  onClick={() => {
                    setMegaMenu(null);
                    setMobileOpen(false);
                  }}
                >
                  <span className="znav-flyout-icon">{card.icon}</span>
                  <h5 className="znav-flyout-title">{card.title}</h5>
                  <p className="znav-flyout-desc">{card.desc}</p>
                  <span className="znav-flyout-arrow" aria-hidden="true">
                    <svg width="15" height="15" viewBox="0 0 24 24" fill="none">
                      <path
                        d="M5 12h14M13 5l7 7-7 7"
                        stroke="currentColor"
                        strokeWidth="2.2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </span>
                </Link>
              ))}
            </div>
          </div>
        )}

        {/*------------------- MEGA FLYOUT PANEL: INTERVIEW PREP ------------------*/}
        {megaMenu === "interview" && (
          <div
            className="znav-flyout"
            onMouseEnter={() => openMegaMenu("interview")}
            onMouseLeave={scheduleCloseMegaMenu}
          >
            <div className="znav-flyout-divider" />
            <div className="znav-flyout-grid">
              {INTERVIEW_CARDS.map((card) => (
                <Link
                  key={card.path}
                  to={card.path}
                  className="znav-flyout-card"
                  onClick={() => {
                    setMegaMenu(null);
                    setMobileOpen(false);
                  }}
                >
                  <span className="znav-flyout-icon">{card.icon}</span>
                  <h5 className="znav-flyout-title">{card.title}</h5>
                  <p className="znav-flyout-desc">{card.desc}</p>
                  <span className="znav-flyout-arrow" aria-hidden="true">
                    <svg width="15" height="15" viewBox="0 0 24 24" fill="none">
                      <path
                        d="M5 12h14M13 5l7 7-7 7"
                        stroke="currentColor"
                        strokeWidth="2.2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </span>
                </Link>
              ))}
            </div>
          </div>
        )}
         {/* <Resume isOpen={resumeOpen} onClose={() => setResumeOpen(false)} /> */}
      </nav>
     
      <div className="znav-spacer" aria-hidden="true" />
    </div>
  );
}